import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Inventory.frontend.types'

@Injectable({ providedIn: 'root' })
export class Inventory_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Inventory: Inventory_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
